// removed by extract-text-webpack-plugin
module.exports = {"submitteddialog":"surveyCompleted-module-submitteddialog-d5f66704b94e966510407ce5b03cda11--","submitted-screen":"surveyCompleted-module-submitted-screen-6d256e02815e90b1ed4d8f540f766989--","message":"surveyCompleted-module-message-fc0f93d118ceca77e715fda34c137811--","closeButton":"surveyCompleted-module-closeButton-9cac844e925fbe3ef21938f29a82b06d--"};


//////////////////
// WEBPACK FOOTER
// /src/components/commonComponents/surveyView/surveyCompleted/surveyCompleted.module.scss
// module id = 1928
// module chunks = 0